module.exports = __webpack_public_path__ + "static/media/buildUpIcon.80abd618.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/buildUpIcon.png
// module id = 303
// module chunks = 0